// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getDataLayer, rcBrand } from "@rc/XDL/Utilities/DataLayer";

export const buildDataLayerEvent: any = (props: any) => {
    const state = props.getState();
    const currentPage = getCurrentPage(state)?.type;
    const product = props.parameter?.product;
    const position = props.parameter?.index;
    const location = props.parameter?.carouselType;

    if (state?.xGA?.productClickEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer || !product) {
            return;
        }

        let shortDescription = product.shortDescription || product.productTitle || product.description;
        shortDescription = shortDescription?.replace(/<(?:.|\n)*?>/gm, '');
        shortDescription = shortDescription?.replace(/\s+/g, " ").trim();

        const GA4Data = {
            event: "US001eComProductClick",
            click: {
                actionField: {},
                products: [{
                    name: shortDescription,
                    id: product.erpNumber || product.productERPNumber || product.productErpNumber || product.productNumber,
                    brand: rcBrand,
                    position
                }]
            },
        } as any;


        if (state["xGA"]["includeProductCategory"]) {
            const lifestageValue = product.properties?.lifeStage;
            const benefitsValue = product.properties?.benefits;
            const category = product.properties?.category;
            const variant = product.properties?.variant;

            GA4Data.click.products[0]["lifeStage"] = lifestageValue || "";
            GA4Data.click.products[0]["benefits"] = benefitsValue || "";
            GA4Data.click.products[0]["category"] = category || "";
            GA4Data.click.products[0]["variant"] = variant || "";
        }

        if (location || currentPage) {
            GA4Data.click.actionField = {
                list: location || currentPage
            };
            localStorage.setItem("productLocation", location || currentPage);
        }

        dataLayer.push(GA4Data);
    }
};

export const chain = [
    buildDataLayerEvent,
];

const buildProductDescriptionDataLayerEvent = createHandlerChainRunner(chain, "buildProductDescriptionDataLayerEvent");
export default buildProductDescriptionDataLayerEvent;
